export default {
  "nl": {
    "space": {
      "actions": {
        "assignOtherUnit": "Wijs opnieuw toe",
        "assignSpace": "Ruimte toewijzen",
        "assignUnit": "Unit toewijzen",
        "cancel": "Annuleer",
        "closeEdit": "Sluit edit",
        "create_space": "Maak nieuwe ruimte aan",
        "delete": "Verwijderen",
        "edit": "Bewerken",
        "goToSpaces": "Nieuwe ruimte toevoegen",
        "new": "Nieuwe ruimte",
        "save": "Opslaan",
        "unassign": "Ontkoppel Unit",
        "unassignSpaces": "Ontkoppel Ruimtes"
      },
      "attributes": {
        "category": "Type",
        "description": "Beschrijving",
        "level": "Niveau",
        "name": "Naam",
        "price_value": "Totale verkoopsprijs",
        "price_value_construction": "Constructie aandeel",
        "price_value_land": "Grondaandeel",
        "quotity": "Quotiteit",
        "status": "Status",
        "unit": "Unit"
      },
      "category": {
        "bicyclestorage": "Fietsenstalling",
        "cellar": "Kelder",
        "garagebox": "Garagebox",
        "other": "Overige",
        "outdoor_space": "Buitenruimte",
        "parkinglot": "Parkeerplaats",
        "storage": "Bergplaats",
        "winecellar": "Wijnkelder"
      },
      "labels": {
        "allSpacesAssigned": "Alle ruimtes zijn toegewezen aan een unit.",
        "assignedSpaces": "Toegewezen Ruimtes",
        "internal": "Intern",
        "noCategory": "Geen type gedefinieerd",
        "noSpaceAssigned": "Geen ruimtes toegewezen",
        "noSpaces": "Nog geen ruimtes aanwezig",
        "notAssignedToUnit": "Niet toegewezen aan een unit",
        "onlyAvailableSpacesShown": "Enkel beschikbare ruimtes worden getoond",
        "selectToUnassign": "Selecteer om te ontkoppelen",
        "space": "Ruimte",
        "spaces": "Ruimtes",
        "spacesProject": "Ruimtes in Project {project}",
        "unassignedSpaces": "Beschikbare Ruimtes"
      },
      "validation": {
        "needCategory": "Type is verplicht",
        "needName": "Naam is verplicht",
        "needNumber": "Moet een nummer zijn (bv. 95)",
        "selectSpace": "Selecteer ten minste 1 ruimte"
      }
    }
  }
}